
    import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";


    @Component({
        components: {
            
        }
    })
    export default class Paginator extends Vue {
        @(Prop()!) paginator;
        mounted() {
            
        }
        

        

        get pageNumbers() {
            if (this.paginator.maxPage < 8) {
                return [...Array(this.paginator.maxPage).keys()].map(el => el + 1);
            }
            if (this.paginator.currentPage < 4) {
                return [1, 2, 3, 4, "...", this.paginator.maxPage];
            }
            if (this.paginator.currentPage > this.paginator.maxPage - 3) {
                return [
                    1,
                    "...",
                    this.paginator.maxPage - 3,
                    this.paginator.maxPage - 2,
                    this.paginator.maxPage - 1,
                    this.paginator.maxPage
                ];
            }
            return [
                1,
                "...",
                this.paginator.currentPage - 1,
                this.paginator.currentPage,
                this.paginator.currentPage + 1,
                "...",
                this.paginator.maxPage
            ];
        }

        
        @Watch("paginator.currentPage", {immediate: true, deep: true})
        onUpdatePage(newVal,oldVal){
            this.select(newVal);
        }

        @Emit("pageSelected")
        private select(pageNum) {}
    }
